import { type FeedResponse } from '@services/FeedService';

// How many of this session's swipes the feed list remembers.
export const SWIPED_IDS_LIMIT = 500;

/**
 * Remembers a swiped card's id, newest last; past `limit` the oldest is
 * forgotten. Ids are kept as strings, whatever type a page carried.
 */
export const rememberSwipedId = (
  swipedIds: Set<string>,
  id: string | number,
  limit = SWIPED_IDS_LIMIT,
) => {
  const key = String(id);
  swipedIds.delete(key);
  swipedIds.add(key);

  while (swipedIds.size > limit) {
    const oldest = swipedIds.values().next().value;
    if (oldest === undefined) break;
    swipedIds.delete(oldest);
  }
};

/**
 * The page without the cards swiped in this session; ad placeholders stay.
 * A refill can reach the server before the swipe that prompted it, and then
 * brings the swiped card back.
 */
export const withoutSwipedIds = (
  items: FeedResponse[],
  swipedIds: ReadonlySet<string>,
) =>
  swipedIds.size === 0
    ? items
    : items.filter(
        (item) => !('id' in item) || !swipedIds.has(String(item.id)),
      );
